<template>

  
 
  <div id="sectionone" class="container-fluid g-0">
    <div id="kayacredit" class="container">
      
      <div class="row">
        <div class="col-6">
          <img class="img-fluid mx-auto d-block"  src="./../assets/kayacredit-suysing.jpg" />
        </div>
        <div class="col-6">
          <div class="sp20"></div>
          <h3 style="fontFamily:Nunito">Suy Sing Payment Confirmation</h3>
          <div class="sp20"></div>

          <input
            size="40"
            className="kc"
            aria-invalid="false"
            placeholder="Transaction Number"
            type="text"
            v-model="username"
            

          />
          <input
          size="40"
          className="kc"
          aria-invalid="false"
          type="text" 
            placeholder="OTP"
          v-model="password"
          
          :maxLength=6  
          @keypress="isNumber($event)" 
          />

       
            <button @click="login" class="btn btn-primary" :disabled="disablebutton">Submit</button>
        
        </div>
     
      </div>
    </div>
    
  </div>

  <div class="row">
    <div class="sp50"></div>
  </div>

</template>

<script>
import axios from 'axios';
import VueQrcode from '@chenfengyuan/vue-qrcode';
  import 'vue3-toastify/dist/index.css'
  import { Modal, Button } from 'ant-design-vue';
 

import 'sweetalert2/dist/sweetalert2.min.css';
export default {
 components: {
  'a-modal': Modal, 
    'a-button': Button,
 
  VueQrcode
 },
 
 setup() {
 },
  data() {
    return {
      disablebutton:false,
        username: '',
        password: '',};
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    
  },
    validateNumericInput(event) {
      const charCode = event.which || event.keyCode;
      // Allow digits (0-9) and the dot (46)
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
      }
    },
  
      
    login() {
      this.disablebutton = true;
      axios.post("/api/shop"+"/confirmation",{transaction_number: this.username, otp: this.password},{
        headers:{
          "Accept": "application/json"
        } 
      }).then(response => {
         
           if (response.data.message === "Credit Limit Exceed."){
            
             this.username ="";
         this.password =""; 
            this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon: 'warning',
         title: 'Kaya Credit Inventory Financing ',
         text: response.data.message, }
      );
      
      this.disablebutton = false;
        }
       else if (response.data.message === "Invalid Transaction Number."){
        this.username ="";
        this.password =""; 
            this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon: 'error',
         title: 'Kaya Credit Inventory Financing ',
         text: response.data.message, }
      );
      
      this.disablebutton = false;
        }
        else if (response.data.message === "Transaction was not confirmed within the cut-off."){
           this.username ="";
         this.password =""; 
          this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon:'error',
         title: 'Kaya Credit Inventory Financing ',
         text: response.data.message, }
      );
      
      this.disablebutton = false;
      
        }
        
        else if (response.data.message === "Verification Sucessful! Please wait for your transaction confirmation via SMS"){
         this.username ="";
         this.password =""; 
            this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon: 'success',
         title: 'Kaya Credit Inventory Financing ',
         text: "Verification Sucessful! Please wait for your transaction confirmation via SMS.", }
      );
      
      
      this.disablebutton = false;
        }
       
      }).catch(error => {
         if (error.response.data.message === "Invalid OTP."){
             this.username ="";
         this.password =""; 
            this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon: 'error',
         title: 'Kaya Credit Inventory Financing ',
         text: error.response.data.message, }
      );
      
      
      this.disablebutton = false;
        }else if (error.response.data.message ===  "Failed to confirm transaction. Please contact customer support."){
             this.username ="";
         this.password =""; 
            this.$swal({
         toast: true,
         position: 'top-end',
         showConfirmButton: true,
        
         icon:'error',
         title: 'Kaya Credit Inventory Financing ',
         text: error.response.data.message, }
      );
      
      
      this.disablebutton = false;
        }  
      });
        }
        
}
}
</script>

<style>
#navbar {
  background: #0f3e82;
  
}

#kayacredit {
  border: 2px dashed #d1d1d1;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  width: 100%;
  padding: 20px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 800;
}

.kc {
  border: 1px solid #ddd;
  color: #808080;
  width: 100% !important;
  margin-bottom: 10px;
  font-family: "Roboto";
  font-weight: 300;
  border-radius: 5px;
  line-height: 30px;
  padding: 10px;
}

.kc:hover,
.kc:focus,
.kc:active {
  outline: none;
  border: 1px solid #ddd;
}

.kc-btn {
  background: #0f3e82 !important;
  border-radius: 20px;
  font-family: "Roboto";
  font-weight: 300;
  font-size: 17px;
  width: 180px;
  float: left;
  color: #fff;
  border: 1px solid #0f3e82;
  line-height: 40px;
  margin-top: 10px;
}
.kc-btn:hover {
  background-color: #fff !important;
  color: #0f3e82;
  border: 1px solid #0f3e82;
}

</style>